import { useCallback } from "react";
import { Route, Routes, Navigate } from "react-router-dom";
import Login from "../identity/Login";
import SignUp from "../identity/SignUp";
import ForgotPassword from "../identity/ForgotPassword";
import Settings from "../settings/Setting";
import ApiKeys from "../settings/ApiKeys";
import EmailVerify from "../identity/EmailVerify";
import ZoomRedirect from "../pages/ZoomRedirect";
import UnifiedDocumentsPage from "../pages/Unified";
import DetailPage from "../pages/DetailPage";
import DocumentPage from "../pages/DocumentPage";
import LiveTapPage from "../pages/LiveTapPage";
import ShareAcceptPage from "../pages/ShareAcceptPage";
import PublicLiveTapPage from "../pages/PublicLiveTapPage";

// Routes that render for anyone, above the login gate (TT-1110): the live
// link's token is the whole credential, so no session is asked for.
export const PUBLIC_LIVE_PATH = "/live/:token";

function useRoutes() {
  const publicRoutes = useCallback(() => {
    return (
      <Routes>
        <Route exact path={PUBLIC_LIVE_PATH} element={<PublicLiveTapPage />} />
      </Routes>
    );
  }, []);

  const unAuthRoutes = useCallback(() => {
    return (
      <Routes>
        <Route exact path="/login" element={<Login />} />
        <Route exact path="/signup" element={<SignUp />} />
        <Route exact path="/forgot-password" element={<ForgotPassword />} />
        <Route exact path="/email_verify" element={<EmailVerify />} />
        <Route exact path="/zoom" element={<ZoomRedirect />} />
        <Route path="*" element={<Navigate to="/login" replace={true} />} />
      </Routes>
    );
  }, []);

  const accountActiveRoutes = useCallback((redirect) => {
    return (
      <Routes>
        <Route exact path="/" element={<UnifiedDocumentsPage />} />
        <Route exact path="/login" element={<Navigate to={"/"} />} />
        <Route exact path="/signup" element={<Navigate to={"/"} />} />
        <Route exact path="/settings" element={<Settings />} />
        <Route exact path="/settings/api-keys" element={<ApiKeys />} />
        <Route exact path="/tapestry/:tapId" element={<DetailPage />} />
        <Route exact path="/document/:docId" element={<DocumentPage />} />
        <Route exact path="/live-tap/:docId" element={<LiveTapPage />} />
        <Route exact path="/share/accept/:shareId" element={<ShareAcceptPage />} />
        <Route exact path="/zoom" element={<ZoomRedirect loggedIn />} />
        <Route exact path="*" element={<Navigate to={"/"} />} />
      </Routes>
    );
  }, []);

  const testAccountRoutes = useCallback(() => {
    return (
      <Routes>
        <Route exact path="/" element={<UnifiedDocumentsPage />} />
        <Route exact path="/settings" element={<Settings />} />
        <Route exact path="*" element={<Navigate to={"/"} />} />
      </Routes>
    );
  }, []);

  return { publicRoutes, unAuthRoutes, accountActiveRoutes, testAccountRoutes };
}

export { useRoutes };
